import { formatDate, FORMAT } from '../../../lib/utils';
import { ReactComponent as DeleteSvg } from '../../../assets/svg/delete.svg';
import request from '../../../lib/request';

const ReplyItem = ({ item, index, getMessageReplies }) => {
  const handleDelete = async () => {
    try {
      if (!window.confirm('Are you sure you want to delete this reply?')) {
        return;
      }

      const { result } = await request.delete(`/message/reply/${item.id}`);

      if (!result) {
        return alert('Failed to delete.');
      }

      await getMessageReplies();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div
      key={item.id}
      className={`relative ${index === 0 ? 'mt-4' : ''}`}
    >
      <div className='flex justify-end'>
        <div className='border rounded-t-xl rounded-l-xl border-b-slate-400 px-2 pt-1 pb-2 w-4/5'>
          <div
            className={`flex-1 mr-8 ${
              item.deletedAt ? 'italic opacity-40' : 'font-semibold'
            }`}
          >
            <div className='break-all'>{item.content}</div>
          </div>
          {!item.deletedAt && (
            <div className='absolute top-[10px] right-3'>
              <DeleteSvg
                className='size-3 cursor-pointer'
                onClick={handleDelete}
              />
            </div>
          )}
        </div>
      </div>
      <div className='text-[10px] leading-tight opacity-40 text-right mr-1'>
        {formatDate(new Date(item.createdAt))}{' '}
        {formatDate(new Date(item.createdAt), FORMAT.HOURMIN)}
      </div>
      <div
        className={`absolute border-l-[1px] border-slate-400 left-1/2 ${
          index === 0 ? 'h-[18px] top-[-17px]' : 'h-[22px] top-[-21px]'
        }`}
      ></div>
    </div>
  );
};

export default ReplyItem;
